import deepmerge from 'deepmerge'

import { AppConfig } from '../app-config'
import developmentConfig from './development'

const stagingConfig = deepmerge<AppConfig>(developmentConfig, {
  baseApiPath: 'https://staging-api.databiologics.com/',
  authHost: 'https://staging-auth.databiologics.com/',
  helixLoginUrl: 'https://helix-staging.databiologics.com/login',
  tableauProductionBaseUrl: 'https://tableau.databiologics.com/',
  tableauProductionEmbeddedApiUrl:
    'https://tableau.databiologics.com/javascripts/api/tableau.embedding.3.latest.min.js',
  tableauStagingBaseUrl: 'https://tableau-staging.databiologics.com/',
  tableauStagingEmbeddedApiUrl:
    'https://tableau-staging.databiologics.com/javascripts/api/tableau.embedding.3.latest.min.js',
  googleMapsApiKey: 'AIzaSyDI2QYc4_MUQBPdgJeefb1sAQkEeAvf35g',
  stripePublictKey:
    'pk_test_51Mt0Y9Avm1kprluZY3C8E1ckDIwUgzJufUXnh7jCwT4YKC5P2rgAar1zlqdXDSPf6xIHHvtfQmXHZpOG0MKsEbdQ00UYx3BNJp',
  sentryDSN:
    'https://bb0b293ad9a03c331851afda34909b43@o4510903226531840.ingest.us.sentry.io/4510975824625664',
  patientUrl: 'https://staging-patient.databiologics.com',
  cdnPath: 'https://staging-cdn.databiologics.com',
})

export default stagingConfig
